import { useCallback, useEffect } from 'react';
import { GEOLOCATION_PERMISSION } from '../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { setGps } from '../store/reducers/gps';
import { askUserPermission, normalizePermission } from '../utils/helper';

const useGeolocationPermission = (onChange) => {
	const dispatch = useDispatch();
	const { permission } = useSelector((store) => store?.gps);

	const checkPermission = useCallback(async () => {
		try {
			if (navigator.permissions?.query) {
				const status = await navigator.permissions.query({ name: 'geolocation' });
				let normalized = normalizePermission(status.state);

				if (normalized === GEOLOCATION_PERMISSION.PROMPT) {
					normalized = await askUserPermission();
				}

				dispatch(setGps({ permission: normalized }));
				onChange?.(normalized);

				status.onchange = () => {
					const next = normalizePermission(status.state);

					dispatch(setGps({ permission: next }));
					onChange?.(next);
				};
			} else {
				const fallback = await askUserPermission();

				dispatch(setGps({ permission: fallback }));
				onChange?.(fallback);
			}
		} catch (err) {
			dispatch(setGps({ permission: GEOLOCATION_PERMISSION.UNKNOWN }));
			onChange?.(GEOLOCATION_PERMISSION.UNKNOWN);
		}
	}, [onChange]);

	useEffect(() => {
		checkPermission();
	}, [checkPermission]);

	return { permission };
};

export default useGeolocationPermission;
